// extracted by mini-css-extract-plugin
export default {"adornment":"FY6f5QZbQPdgrG5ximNs"};